/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Testimonial_1_QuoteInputs */

const en_landing_testimonial_1_quote = /** @type {(inputs: Landing_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You stay in control of final submissions. Review tailored materials, privacy settings, and consent choices in one place.`)
};

const de_landing_testimonial_1_quote = /** @type {(inputs: Landing_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du behaeltst die volle Kontrolle. Alle KI-Ausgaben pruefst, bearbeitest und genehmigst du vor der Einreichung. Datenschutzdetails unter /privacy.`)
};

const fr_landing_testimonial_1_quote = /** @type {(inputs: Landing_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu gardes le contrôle. Tous les résultats IA sont examinés, modifiés et approuvés par toi avant soumission. Détails confidentialité : /privacy.`)
};

const es_landing_testimonial_1_quote = /** @type {(inputs: Landing_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantienes el control. Todos los resultados de IA son revisados, editados y aprobados por ti antes del envío. Detalles de privacidad: /privacy.`)
};

const it_landing_testimonial_1_quote = /** @type {(inputs: Landing_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantieni il controllo. Tutti gli output IA vengono esaminati, modificati e approvati da te prima dell'invio. Dettagli privacy: /privacy.`)
};

const nl_landing_testimonial_1_quote = /** @type {(inputs: Landing_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je behoudt de controle. Alle AI-uitvoer wordt door jou beoordeeld, bewerkt en goedgekeurd vóór indiening. Privacydetails: /privacy.`)
};

const pl_landing_testimonial_1_quote = /** @type {(inputs: Landing_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zachowujesz kontrole. Wszystkie wyniki AI sa przegladane, edytowane i zatwierdzane przez ciebie przed wyslaniem. Szczegoly prywatnosci: /privacy.`)
};

const fi_landing_testimonial_1_quote = /** @type {(inputs: Landing_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinulla on hallinta. Kaikki tekoalytulokset tarkistetaan, muokataan ja hyvaksytaan ennen laehettamistae. Tietosuojatiedot: /privacy.`)
};

const da_landing_testimonial_1_quote = /** @type {(inputs: Landing_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du beholder kontrollen. Alle AI-output gennemgaes, redigeres og godkendes af dig foer indsendelse. Privatlivsoplysninger: /privacy.`)
};

const sv_landing_testimonial_1_quote = /** @type {(inputs: Landing_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du behaller kontrollen. Alla AI-utdata granskas, redigeras och godkans av dig infoer inlamning. Integritetsinformation: /privacy.`)
};

/**
* | output |
* | --- |
* | "You stay in control of final submissions. Review tailored materials, privacy settings, and consent choices in one place." |
*
* @param {Landing_Testimonial_1_QuoteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_testimonial_1_quote = /** @type {((inputs?: Landing_Testimonial_1_QuoteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Testimonial_1_QuoteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_testimonial_1_quote(inputs)
	if (locale === "fr") return fr_landing_testimonial_1_quote(inputs)
	if (locale === "es") return es_landing_testimonial_1_quote(inputs)
	if (locale === "it") return it_landing_testimonial_1_quote(inputs)
	if (locale === "nl") return nl_landing_testimonial_1_quote(inputs)
	if (locale === "pl") return pl_landing_testimonial_1_quote(inputs)
	if (locale === "fi") return fi_landing_testimonial_1_quote(inputs)
	if (locale === "da") return da_landing_testimonial_1_quote(inputs)
	if (locale === "sv") return sv_landing_testimonial_1_quote(inputs)
	return en_landing_testimonial_1_quote(inputs)
});